import {
  CheckPriceProps,
  useExistingProductState,
} from "Components/Features/CheckPrice";
import React, { useEffect } from "react";
import {
  BOAT_ABOUT_STEP,
  BOAT_FIND_STEP,
  BOAT_PRICE_STEP,
  BOAT_STEPS,
} from "./boatSteps";

import { Icons } from "@storebrand-digital/insurance-definitions";
import { ActiveStep } from "Components/ActiveStep";
import { ProductTile } from "Components/Features/CheckPrice/Tiles/ProductTile";
import { useTexts } from "Components/TextContext";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { setCheckPriceProducts } from "Store/analytics/analyticsSlice";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { useDispatch } from "react-redux";
import { Route } from "react-router-dom";
import { BoatProductDetails } from "./ProductDetails";
import { BoatProductIntro } from "./ProductIntro";
import { BoatProductPrice } from "./ProductPrice";
import { PATH } from "./boatConstants";

export const BoatCheckPrice = (props: CheckPriceProps): JSX.Element => {
  const dispatch = useDispatch();
  const { updatePriceRequest } = props;
  const { getText } = useTexts();
  useExistingProductState(INSURANCE_NAME_VALUE.BOAT);
  useEffect(() => {
    dispatch(setCheckPriceProducts([INSURANCE_NAME_VALUE.BOAT]));
  }, []);

  return (
    <ProductTile
      title={getText("boatform.header.productname")}
      productName={getText("insuranceproduct.boat.name")}
      productBackendName={ProductBackendName.BOAT}
      productPath={PATH}
      productSteps={BOAT_STEPS}
      iconName={Icons.BOAT}
    >
      <Route
        exact
        path={`${PATH}/${BOAT_FIND_STEP.id}`}
        render={() => (
          <ActiveStep>
            <BoatProductIntro />
          </ActiveStep>
        )}
      />
      <Route
        exact
        path={`${PATH}/${BOAT_ABOUT_STEP.id}`}
        render={() => (
          <ActiveStep>
            <BoatProductDetails updatePriceRequest={updatePriceRequest} />
          </ActiveStep>
        )}
      />
      <Route
        exact
        path={`${PATH}/${BOAT_PRICE_STEP.id}`}
        render={() => (
          <ActiveStep>
            <BoatProductPrice />
          </ActiveStep>
        )}
      />
    </ProductTile>
  );
};
